module.exports = __webpack_public_path__ + "img/3-place-medal-simple.18e4a20e.svg";